import React, { useContext } from "react";
import { RegistrationFormContext } from "./types";
import { InputRadio } from "../../../../HtmlComponents/InputRadio";
import { InputCheckbox } from "../../../../HtmlComponents/InputCheckbox";
import { InputElement } from "../../../../HtmlComponents/InputElement";

const Section10 = () => {
  const {
    association, setAssociation,
    interestInOrganizations, setInterestInOrganizations,
    contract, setContract,
  } = useContext(RegistrationFormContext);

  const contractArr: string[] = ["Usage d'un local", "Usage d'un materiel", "Association", "Societe d'un civile de moyen", "Medecine salariee ou medecine de travail"]

  return (<>
    <div>
      <p className='font-bold text-main'>{"37) "}si vous exercez en association Quels sont les noms et titres de votre ou de vos associés: </p>
      <InputCheckbox 
        name="Oui"
        id="associationOui" 
        value={association} 
        setValue={setAssociation}
      />
      {(association === true || (association !== "false" && typeof association === "string")) && <InputElement inputClass='md:w-1/2' name='Laquelle?' value={association} setValue={setAssociation}/>}
    </div>
    <div>
      <p className='font-bold text-main'>{"38) "}Avez-vous des interets dans un organisme ou dans une entreprise touchant les professions mdeicales ou paramedicale: </p>
      <InputCheckbox 
        name="Oui"
        id="interestInOrganizationsOui" 
        value={interestInOrganizations} 
        setValue={setInterestInOrganizations}
      />
      {(interestInOrganizations === true || (interestInOrganizations !== "false" && typeof interestInOrganizations === "string")) && <InputElement inputClass='md:w-1/2' name='Laquelle?' value={interestInOrganizations} setValue={setInterestInOrganizations}/>}
    </div>
    <div>
      <p className='font-bold text-main'>{"39) "}Avez-vous deja conclu un ( ou des ) contract(s) ayant pour objet l'exercice de votre profession: </p>
      <InputRadio 
        checked={contract === "Usage d'un local" && true} 
        labelName="Usage d'un local"
        id="UsageUnLocal" 
        value={"Usage d'un local"} 
        setValue={setContract}
      />
      <InputRadio 
        checked={contract === "Usage d'un materiel" && true} 
        labelName="Usage d'un materiel"
        id="UsageUnMateriel" 
        value={"Usage d'un materiel"} 
        setValue={setContract}
      />
      <InputRadio 
        checked={contract === "Association" && true} 
        labelName="Association"
        id="ContractAssociation" 
        value={"Association"} 
        setValue={setContract}
      />
      <InputRadio 
        checked={contract === "Societe d'un civile de moyen" && true} 
        labelName="Societe d'un civile de moyen"
        id="SocieteUnCivileDeMoyen" 
        value={"Societe d'un civile de moyen"} 
        setValue={setContract}
      />
      <InputRadio 
        checked={contract === "Medecine salariee ou medecine de travail" && true} 
        labelName="Medecine salariee ou medecine de travail"
        id="MedecineSalarieeOuMedecineDeTravail" 
        value={"Medecine salariee ou medecine de travail"} 
        setValue={setContract}
      />
      <InputRadio 
        checked={(contract && !contractArr.includes(contract)) ? true : false} 
        labelName="Autre"
        id="contractAutre" 
        value={"Autre"} 
        setValue={setContract}
      />
      {contract && !contractArr.includes(contract) && <InputElement inputClass='md:w-1/2' name='Laquelle?' value={contract} setValue={setContract}/>}
    </div> 
  </>);
};

export default Section10;
